import type { ReactNode } from 'react';
import { Badge, type MantineStyleProps } from '@mantine/core';




type Props = {
  children?: ReactNode;
  color?: string;
} & MantineStyleProps;

export function BadgeBlock({ children, color, ...rest }: Readonly<Props>) {
  return (
    <Badge
      size="sm"
      radius="sm"
      variant="light"
      color={color}
      style={{
        '--badge-bd': `1px solid color-mix(in srgb, var(--badge-color), transparent 40%)`
      }}
      {...rest}
    >
      {children}
    </Badge>
  );
}

